import type { ButtonHTMLAttributes, ReactNode } from 'react';

/** {@link ToolButton} のプロパティ。 */
export interface ToolButtonProps extends Omit<
  ButtonHTMLAttributes<HTMLButtonElement>,
  'type' | 'aria-pressed'
> {
  /** 表示名。アイコンのみの表示でもアクセシブルな名前として使う（NFR-ACC-003） */
  readonly label: string;
  /** ラベルの前に表示するアイコン */
  readonly icon?: ReactNode;
  /** トグルボタンの場合の押下状態 */
  readonly pressed?: boolean;
  /** `true` のときラベルを視覚的に隠す（スクリーンリーダーには読み上げられる） */
  readonly iconOnly?: boolean;
}

/**
 * ツールバー用のボタン。タッチターゲットは 44×44px 以上を保証する（NFR-USA-002）。
 */
export function ToolButton({
  label,
  icon,
  pressed,
  iconOnly = false,
  className,
  ...rest
}: ToolButtonProps) {
  const classes = ['rcs-tool-button', pressed ? 'rcs-tool-button--pressed' : '', className ?? '']
    .filter(Boolean)
    .join(' ');
  return (
    <button
      {...rest}
      type="button"
      className={classes}
      aria-pressed={pressed}
      title={iconOnly ? label : rest.title}
    >
      {icon}
      <span className={iconOnly ? 'rcs-visually-hidden' : 'rcs-tool-button__label'}>{label}</span>
    </button>
  );
}
